import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Input,
  Select,
  Box,
  Text,
  Flex,
  Card,
  Tooltip,
  VisuallyHidden,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { checkFileTypesAndSize, statesList } from "../../Common/utils";
import {
  getCommodity,
  getProcess,
  getProgram,
  getSingleProgram,
  reNewRC,
  scopeExtension,
} from "../../api";
import dompurify from "dompurify";
import { useEffect } from "react";
import { MultiSelect } from "chakra-multiselect";
import { v4 as uuidv4 } from "uuid";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductCategory,
  getProductClassification,
} from "../../redux/product/ProductSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAllPrograms } from "../../redux/program/ProgramSlice";
import {
  INITIAL_VALUES,
  PRODUCT_INITIAL_VALUES,
} from "../../Pages/RegistrationCertificate";
import { toast } from "react-toastify";
import { FiUpload } from "react-icons/fi";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import axios from "axios";

function ScopeExtensionModal({ isOpen, onClose, companyDetails }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [unitTypes, setUnitTypes] = useState([
    "FACILITY",
    "INTERNAL SUBCONTRACTOR",
    "EXTERNAL SUBCONTRACTOR",
  ]);
  const [unitValues, setUnitValues] = useState(INITIAL_VALUES);
  const [productValues, setProductValues] = useState(PRODUCT_INITIAL_VALUES);
  const [units, setUnits] = useState([]);
  const [products, setProducts] = useState([]);
  const [commodityValues, setCommodityValues] = useState([]);
  const [processValues, setProcessValues] = useState([]);
  const [programValues, setProgramValues] = useState([]);
  const [selectedProcessValue, setSelectedProcessValue] = useState([]);
  const [customProcessValue, setCustomProcessValue] = useState([]);
  const [selectedProgramValue, setSelectedProgramValue] = useState([]);
  const [customProgramValue, setCustomProgramValue] = useState([]);
  const [selectedCommodityValue, setSelectedCommodityValue] = useState([]);
  const [customCommodityValue, setCustomCommodityValue] = useState([]);
  const { productCategory } = useSelector((state) => state.products);
  const { productClassification } = useSelector((state) => state.products);
  const { allPrograms } = useSelector((state) => state.programs);
  const [program, setProgram] = useState([]);
  const [showCertified, setShowCertified] = useState(false);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editableUnitId, setEditableUnitId] = useState(null);
  const [tempEditData, setTempEditData] = useState({});
  const [editableProductId, setEditableProductId] = useState(null);
  const [tempEditProductData, setTempEditProductData] = useState({});

  const handleEditClick = (unit) => {
    setEditableUnitId(unit.id);
    setTempEditData({ ...unit });
  };

  const handleFieldChange = (field, value) => {
    setTempEditData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveChanges = () => {
    setUnits((prevUnits) =>
      prevUnits.map((unit) =>
        unit.id === editableUnitId ? { ...unit, ...tempEditData } : unit
      )
    );
    setEditableUnitId(null);
    setTempEditData({});
  };

  const handleEditProductClick = (product) => {
    setEditableProductId(product.id);
    setTempEditProductData(product);
  };

  const handleFieldProductChange = (field, value) => {
    setTempEditProductData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveProductChanges = () => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === editableProductId ? { ...tempEditProductData } : product
      )
    );
    setEditableProductId(null);
    setTempEditProductData({});
  };

  const getProcessName = (processId) => {
    return processValues.filter((process) => process.id === processId)?.[0]
      ?.value;
  };

  const getProgramName = (programId) => {
    return programValues.filter((program) => program.id === programId)?.[0]
      ?.value;
  };

  const token = localStorage.getItem("cu_user");

  const handleFileUpload = async (event) => {
    const newFiles = Array.from(event.target.files);
    let errorMessage = "";
    let filesToAdd = [];

    for (let i = 0; i < newFiles.length; i++) {
      const file = newFiles[i];
      const validation = checkFileTypesAndSize(
        file.name,
        file.type,
        file.size,
        10485760
      );

      if (validation.isValid) {
        filesToAdd.push(file);
      } else {
        errorMessage = validation.error;
        break; // Exit the loop on the first invalid file
      }
    }

    if (errorMessage) {
      setErrorMessage(errorMessage);
      toast.error(errorMessage);
    } else {
      if (filesToAdd.length > 0) {
        setFiles([...filesToAdd, ...files]);
        toast.success("Your RC document uploaded successfully.");
        setErrorMessage("");
      } else {
        setErrorMessage("No files selected for upload.");
        toast.error("No files selected for upload.");
      }
    }
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles(files.filter((_, index) => index !== indexToRemove));
  };

  const uploadDocuments = async () => {
    const fileFormData = new FormData();

    files.forEach((file) => {
      fileFormData.append("document", file);
    });

    try {
      const fileUploadRequest = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_HOST}/api/document/multiple/upload`,
        data: fileFormData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return fileUploadRequest.data?.data?.map((file) => file?._id);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    setIsLoading(false);
  };

  const getOneProgram = async (id) => {
    let response = await getSingleProgram(id);
    setProgram(response?.data);
  };

  const getProcessList = async () => {
    let response = await getProcess();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setProcessValues(responseData);
  };

  const getCommodityData = async () => {
    let response = await getCommodity();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setCommodityValues(responseData);
  };

  const getProgramList = async () => {
    let response = await getProgram();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setProgramValues(responseData);
  };

  const getCategories = () => {
    try {
      const result = dispatch(getProductCategory());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getClassification = () => {
    try {
      const result = dispatch(getProductClassification());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getPrograms = () => {
    try {
      const result = dispatch(getAllPrograms());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getProductCategoryName = (productCategoryId) => {
    return productCategory?.data?.filter(
      (productCategory) => productCategory?._id === productCategoryId
    )?.[0]?.name;
  };

  const getProductClassificationName = (productClassificationId) => {
    return productClassification?.data?.filter(
      (productClassification) =>
        productClassification?._id === productClassificationId
    )?.[0]?.name;
  };

  const getProductCertificationName = (productCertificationId) => {
    return allPrograms?.data?.filter(
      (productCertification) =>
        productCertification?._id === productCertificationId
    )?.[0]?.name;
  };

  function getProductLabelGradeName(gradeId) {
    // Iterate over the data array in allPrograms
    for (const program of allPrograms?.data) {
      // Check if program_labelGrade exists and is an array
      if (Array.isArray(program?.program_labelGrade)) {
        // Search for the gradeId in program_labelGrade
        const labelGrade = program.program_labelGrade.find(
          (grade) => grade.id === gradeId
        );
        // If found, return the name of the label grade
        if (labelGrade) {
          return labelGrade.name;
        }
      }
    }
    // If no matching gradeId is found, return null or a message
    return null; // Or return 'Grade ID not found';
  }

  const addUnits = (unitValues) => {
    if (unitValues.unitType === "MAIN") {
      setUnitTypes([
        "FACILITY",
        "INTERNAL SUBCONTRACTOR",
        "EXTERNAL SUBCONTRACTOR",
      ]);
    }
    if (unitValues?.name?.trim() === "") {
      toast.error("Please add unit's name.");
      return;
    }
    if (unitValues?.raw_address?.trim() === "") {
      toast.error("Please add unit's address.");
      return;
    }
    if (unitValues?.unitType?.trim() === "") {
      toast.error("Please add unit's type.");
      return;
    }

    if (unitValues?.state === "") {
      toast.error("Please add unit's state.");
      return;
    }

    if (unitValues?.numberOfEmployees <= 0) {
      toast.error("Nuber of employees should be greater than 0.");
      return;
    }

    if (!(selectedProcessValue?.length > 0)) {
      toast.error("Please add atleast one process.");
      return;
    }

    if (!(selectedProgramValue?.length > 0)) {
      toast.error("Please add atleast one program.");
      return;
    }

    if (
      unitValues.name.trim() !== "" &&
      unitValues.unitType.trim() !== "" &&
      unitValues.raw_address.trim() !== "" &&
      unitValues.state !== "" &&
      unitValues.numberOfEmployees > 0 &&
      selectedProcessValue?.length > 0 &&
      selectedProgramValue?.length > 0
    ) {
      const unitObject = {
        id: uuidv4(),
        name: unitValues.name,
        address: {
          // location: {
          //   coordinates: [
          //     coordinates?.lat ? coordinates?.lat : null,
          //     coordinates?.lng ? coordinates?.lng : null,
          //   ],
          // },
          state: unitValues.state,
          city: unitValues.city,
          country: unitValues.country,
          pinCode: unitValues.pinCode,
          raw_address: unitValues.raw_address,
        },
        numberOfEmployees: unitValues.numberOfEmployees,
        unitType: unitValues.unitType,
        processIds: customProcessValue.map((values) => values.id),
        programIds: customProgramValue.map((values) => values.id),
      };

      setUnits((unit) => [unitObject, ...unit]);
      toast.success("Unit added successfully");
      unitValues.name = "";
      unitValues.state = "";
      unitValues.city = "";
      unitValues.country = "";
      unitValues.pinCode = "";
      unitValues.raw_address = "";
      unitValues.unitType = "";
      unitValues.numberOfEmployees = null;
      setSelectedProcessValue([]);
      setCustomProcessValue([]);
      setSelectedProcessValue([]);
      setSelectedProgramValue([]);
    }
  };

  const addProducts = (productValues) => {
    if (productValues?.productName?.trim() === "") {
      toast.error("Please add product's name.");
      return;
    }

    if (productValues?.productCategory === "") {
      toast.error("Please add product's category.");
      return;
    }

    if (productValues?.productClassification === "") {
      toast.error("Please add product's classification.");
      return;
    }

    if (productValues?.productCertification === "") {
      toast.error("Please add product's certification.");
      return;
    }

    if (productValues?.productLabelGrade === "") {
      toast.error("Please add product's label grade.");
      return;
    }

    if (
      productValues?.productName?.trim() !== "" &&
      productValues?.productCategory !== "" &&
      productValues?.productClassification !== "" &&
      productValues?.productCertification !== "" &&
      productValues?.productLabelGrade !== ""
    ) {
      const productObject = {
        id: uuidv4(),
        name: dompurify.sanitize(productValues.productName),
        productCategory: dompurify.sanitize(productValues.productCategory),
        productClassification: dompurify.sanitize(
          productValues.productClassification
        ),
        program: dompurify.sanitize(productValues.productCertification),
        certifiedLabelGrade: dompurify.sanitize(
          productValues.productLabelGrade
        ),
        productComposition: [
          {
            commodity: program?.program_labelGrade?.map(
              (grade) => grade.commodities.map((data) => data.commodityId.id)[0]
            ),
          },
        ],
        ncProductComposition: customCommodityValue.map((values) => ({
          commodity: values.id,
        })),
      };
      setProducts((product) => [productObject, ...product]);
      toast.success("Product added successfully");
      setProductValues(PRODUCT_INITIAL_VALUES);
      setProgram([]);
      setSelectedCommodityValue([]);
      setCustomCommodityValue([]);
    }
  };

  const handleFinalSubmit = async () => {
    // if (units?.length <= 0) {
    //   toast.info("Please add at least one unit before submitting.");
    //   return;
    // }

    // if (products.length <= 0) {
    //   toast.info("Please add at least one product before submitting.");
    //   return;
    // }

    if (files?.length <= 0) {
      return toast.info(
        "Please add at least one GST or any company related document."
      );
      return;
    }

    setIsLoading(true);
    const documentIds = await uploadDocuments();
    if (documentIds === undefined) {
      toast.info(
        "Please add at least one GST or any company related document."
      );
      return;
    }

    const sanitizedUnits = units?.map(({ companyId, ...rest }) => rest);
    const sanitizedProducts = products?.map(({ companyId, ...rest }) => rest);

    let values = {
      units: sanitizedUnits,
      products: sanitizedProducts,
      documents: documentIds,
    };

    const response = await scopeExtension(values);
    if (response?.data?.status === "success") {
      toast.success("Application submitted successfully.");
      onClose();
      setUnitTypes([
        "MAIN",
        "FACILITY",
        "INTERNAL SUBCONTRACTOR",
        "EXTERNAL SUBCONTRACTOR",
      ]);
      setFiles([]);
      onClose();
    } else {
      toast.error(response?.message || "Something went wrong.");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getProcessList();
    getProgramList();
    getCategories();
    getClassification();
    getPrograms();
    getCommodityData();
  }, []);

  return (
    <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justifyContent={"space-between"}>
            Scope Extension
            <Button bg="transparent" onClick={onClose}>
              <CloseIcon color="crimson" fontSize="30px" />
            </Button>
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Tabs>
            <TabList>
              <Tab
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Units
              </Tab>
              <Tab
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Products
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Grid gap={"2rem"}>
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Facility/Site Name{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <Input
                      type="text"
                      id="unitName"
                      color={"#141D43"}
                      value={unitValues.name}
                      border="2px solid  #8fd0fd !important"
                      onChange={(e) => {
                        setUnitValues({
                          ...unitValues,
                          name: e.target.value,
                        });
                      }}
                      marginTop="5px"
                      bg={"#fff"}
                      fontSize={"14px"}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      mt="1rem"
                    >
                      Address{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <Input
                      type="text"
                      color={"#141D43"}
                      id="unitRawAddress"
                      marginTop="10px"
                      border="2px solid  #8fd0fd !important"
                      w="100%"
                      bg={"#fff"}
                      value={unitValues.raw_address}
                      onChange={(e) => {
                        setUnitValues({
                          ...unitValues,
                          raw_address: e.target.value,
                        });
                      }}
                      fontSize={"14px"}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    <Flex gap="1rem" mt="1rem">
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Latitude
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="5px"
                          id="city"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          // value={coordinates?.lat ? coordinates?.lat : "N/A"}
                          disabled={true}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </Box>
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Longitude
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="5px"
                          id="city"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          // value={coordinates?.lat ? coordinates?.lat : "N/A"}
                          disabled={true}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </Box>
                    </Flex>
                    <Flex gap="1rem" mt="1rem">
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                          mt="1rem"
                        >
                          City{" "}
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="5px"
                          id="unitCity"
                          bg={"#fff"}
                          value={unitValues.city}
                          border="2px solid  #8fd0fd !important"
                          onChange={(e) =>
                            setUnitValues({
                              ...unitValues,
                              city: e.target.value,
                            })
                          }
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </Box>
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                          mt="1rem"
                        >
                          State{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          marginTop={"5px"}
                          bgColor="white"
                          id="unitState"
                          color={" #141D43"}
                          fontSize="sm"
                          value={unitValues.state}
                          border="2px solid  #8fd0fd !important"
                          onChange={(e) => {
                            setUnitValues({
                              ...unitValues,
                              state: e.target.value,
                            });
                          }}
                        >
                          <option hidden="true">Select State</option>
                          {statesList?.map((state, idx) => (
                            <option key={idx}>{state}</option>
                          ))}
                        </Select>
                      </Box>
                    </Flex>

                    <Flex gap="1rem" mt="1rem">
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Pin Code{" "}
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="5px"
                          id="unitPinCode"
                          bg={"#fff"}
                          value={unitValues.pinCode}
                          border="2px solid  #8fd0fd !important"
                          onChange={(e) =>
                            setUnitValues({
                              ...unitValues,
                              pinCode: e.target.value,
                            })
                          }
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </Box>
                      <Box w="50%">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Country{" "}
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="5px"
                          id="unitCountry"
                          bg={"#fff"}
                          value={unitValues.country}
                          border="2px solid  #8fd0fd !important"
                          onChange={(e) =>
                            setUnitValues({
                              ...unitValues,
                              country: e.target.value,
                            })
                          }
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </Box>
                    </Flex>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      mt="1rem"
                    >
                      Type of Unit{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <Select
                      marginTop={"5px"}
                      bgColor="white"
                      color={" #464C64"}
                      id="unitType"
                      border="2px solid  #8fd0fd !important"
                      fontSize="sm"
                      value={unitValues.unitType}
                      onChange={(e) => {
                        setUnitValues({
                          ...unitValues,
                          unitType: e.target.value,
                        });
                      }}
                    >
                      <option hidden="true">Select Unit Type</option>
                      {unitTypes.map((option) => (
                        <option default="true">{option}</option>
                      ))}
                    </Select>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      mt="1rem"
                    >
                      Number of Employees{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <Input
                      type="number"
                      id="numberEmployee"
                      color={"#141D43"}
                      defaultValue={unitValues.numberOfEmployees}
                      value={
                        unitValues.numberOfEmployees === null
                          ? ""
                          : unitValues.numberOfEmployees
                      }
                      border="2px solid  #8fd0fd !important"
                      onChange={(e) => {
                        setUnitValues({
                          ...unitValues,
                          numberOfEmployees: parseInt(e.target.value),
                        });
                      }}
                      marginTop="5px"
                      bg={"#fff"}
                      fontSize={"14px"}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />

                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      mt="1rem"
                    >
                      Type of Processes{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <MultiSelect
                      marginTop={"5px"}
                      options={processValues}
                      value={selectedProcessValue}
                      bgColor="white"
                      color={" #464C64"}
                      toggleAllCheckboxVisibility="always"
                      border="2px solid  #8fd0fd !important"
                      onChange={(value) => {
                        const newArr = value.map(
                          (value) =>
                            processValues.filter(
                              (process) => process.label === value
                            )[0]
                        );
                        setCustomProcessValue(newArr);
                        setSelectedProcessValue(value);
                      }}
                    />
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      mt="1rem"
                    >
                      Please Select program(s) you want to have this unit
                      certified for.{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <MultiSelect
                      marginTop={"5px"}
                      options={programValues}
                      value={selectedProgramValue}
                      bgColor="white"
                      toggleAllCheckboxVisibility="always"
                      color={" #464C64"}
                      onChange={(value) => {
                        const newArr = value.map(
                          (value) =>
                            programValues.filter(
                              (program) => program.label === value
                            )[0]
                        );
                        setCustomProgramValue(newArr);
                        setSelectedProgramValue(value);
                      }}
                    />
                    <Button
                      bg={"#52BBFF"}
                      _hover={{ bg: "#3fa7eb" }}
                      color="white"
                      cursor={"pointer"}
                      mt="1rem"
                      onClick={() => addUnits(unitValues)}
                    >
                      Add Unit
                    </Button>
                  </GridItem>
                  <GridItem
                  // borderLeft={{ base: "", md: "", lg: "3px solid #52BBFF" }}
                  // paddingLeft={{ base: "", md: "", lg: "2rem" }}
                  >
                    <Text
                      color={"#141D43"}
                      fontSize="lg"
                      fontWeight={"800"}
                      marginBottom="5px"
                    >
                      List of Units added
                    </Text>
                    <Box
                      border={"2px solid #2272D5"}
                      width="15%"
                      marginBottom={"1rem"}
                    ></Box>
                    <Accordion allowToggle>
                      {units?.map((unit) => (
                        <AccordionItem
                          key={unit.id}
                          border="1px solid #E2E8F0"
                          borderRadius="md"
                          mb="1rem"
                        >
                          <h2>
                            <AccordionButton>
                              <Box
                                flex="1"
                                textAlign="left"
                                fontWeight="600"
                                color="#2272D5"
                              >
                                {unit.name || "Unit Name Not Provided"}
                              </Box>
                              <AccordionIcon />
                            </AccordionButton>
                          </h2>

                          <AccordionPanel pb={4}>
                            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                              <GridItem>
                                <Text fontWeight="800">
                                  Facility/Site Name:
                                </Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    value={tempEditData.name}
                                    isDisabled
                                    onChange={(e) =>
                                      handleFieldChange("name", e.target.value)
                                    }
                                  />
                                ) : (
                                  <Tooltip label={unit.name}>
                                    <Text>{unit.name || "N/A"}</Text>
                                  </Tooltip>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Address:</Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    isDisabled
                                    value={tempEditData.address?.raw_address}
                                    onChange={(e) =>
                                      handleFieldChange("address", {
                                        ...tempEditData.address,
                                        raw_address: e.target.value,
                                      })
                                    }
                                  />
                                ) : (
                                  <Text>
                                    {unit.address?.raw_address || "N/A"}
                                  </Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">City:</Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    value={tempEditData.address?.city}
                                    marginTop={"10px"}
                                    bgColor="white"
                                    isDisabled
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    onChange={(e) =>
                                      handleFieldChange("address", {
                                        ...tempEditData.address,
                                        city: e.target.value,
                                      })
                                    }
                                  />
                                ) : (
                                  <Text>{unit.address?.city || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">State:</Text>
                                {editableUnitId === unit.id ? (
                                  <Select
                                    value={tempEditData.address?.state}
                                    marginTop={"10px"}
                                    bgColor="white"
                                    isDisabled
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    onChange={(e) =>
                                      handleFieldChange("address", {
                                        ...tempEditData.address,
                                        state: e.target.value,
                                      })
                                    }
                                  >
                                    <option hidden="true">Select State</option>
                                    {statesList?.map((state, idx) => (
                                      <option key={idx}>{state}</option>
                                    ))}
                                  </Select>
                                ) : (
                                  <Text>{unit.address?.state || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Country:</Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    isDisabled
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    value={tempEditData.address?.country}
                                    onChange={(e) =>
                                      handleFieldChange("address", {
                                        ...tempEditData.address,
                                        country: e.target.value,
                                      })
                                    }
                                  />
                                ) : (
                                  <Text>{unit.address?.country || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Pin Code:</Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    marginTop={"10px"}
                                    isDisabled
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    value={tempEditData.address?.pinCode}
                                    onChange={(e) =>
                                      handleFieldChange("address", {
                                        ...tempEditData.address,
                                        pinCode: e.target.value,
                                      })
                                    }
                                  />
                                ) : (
                                  <Text>{unit.address?.pinCode || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Type of Unit:</Text>
                                {editableUnitId === unit.id ? (
                                  <Select
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    isDisabled
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    value={tempEditData.unitType}
                                    onChange={(e) =>
                                      handleFieldChange(
                                        "unitType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option hidden="true">
                                      Select Unit Type
                                    </option>
                                    {unitTypes?.map((option) => (
                                      <option default="true">{option}</option>
                                    ))}
                                  </Select>
                                ) : (
                                  <Text>{unit.unitType || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">
                                  Number of employees:
                                </Text>
                                {editableUnitId === unit.id ? (
                                  <Input
                                    value={tempEditData.numberOfEmployees}
                                    isDisabled
                                    onChange={(e) =>
                                      handleFieldChange(
                                        "numberOfEmployees",
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  <Text>{unit.numberOfEmployees || "N/A"}</Text>
                                )}
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Type of processes</Text>
                                <Text>
                                  {editableUnitId === unit.id ? (
                                    <>
                                      <MultiSelect
                                        marginTop={"10px"}
                                        options={processValues}
                                        value={tempEditData?.processIds?.map(
                                          (processId) => {
                                            const matchingProcess =
                                              processValues.find(
                                                (process) =>
                                                  process.id === processId
                                              );
                                            return matchingProcess
                                              ? matchingProcess.label
                                              : "";
                                          }
                                        )}
                                        bgColor="white"
                                        color={" #464C64"}
                                        toggleAllCheckboxVisibility="always"
                                        border="2px solid  #8fd0fd !important"
                                        onChange={(value) => {
                                          const newArr = value.map((value) => {
                                            const process = processValues.find(
                                              (process) =>
                                                process.label === value
                                            );
                                            return {
                                              label: process.label,
                                              value: process.id,
                                            };
                                          });
                                          setCustomProcessValue(newArr);

                                          const processIds = newArr.map(
                                            (option) => option.value
                                          );

                                          setTempEditData((tempData) => {
                                            return {
                                              ...tempData,
                                              processIds: processIds,
                                            };
                                          });
                                        }}
                                      />
                                    </>
                                  ) : unit?.processIds?.length > 0 ? (
                                    unit?.processIds?.map(
                                      (processId, index) => (
                                        <Text key={index}>
                                          {getProcessName(processId)}
                                        </Text>
                                      )
                                    )
                                  ) : (
                                    "N/A"
                                  )}
                                </Text>
                              </GridItem>

                              <GridItem>
                                <Text fontWeight="800">Type of Program</Text>
                                <Text>
                                  {unit?.programIds?.length > 0
                                    ? unit?.programIds?.map(
                                        (programId, index) => (
                                          <Text key={index}>
                                            {getProgramName(programId)}
                                          </Text>
                                        )
                                      )
                                    : "N/A"}
                                </Text>
                              </GridItem>
                            </Grid>

                            <Box
                              display="flex"
                              justifyContent="flex-end"
                              mt="1rem"
                            >
                              {editableUnitId === unit.id ? (
                                <>
                                  <Button
                                    colorScheme="green"
                                    mr={3}
                                    onClick={saveChanges}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    onClick={() => setEditableUnitId(null)}
                                  >
                                    Cancel
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  colorScheme="blue"
                                  onClick={() => handleEditClick(unit)}
                                >
                                  Edit
                                </Button>
                              )}
                            </Box>
                          </AccordionPanel>
                        </AccordionItem>
                      ))}
                    </Accordion>
                  </GridItem>
                </Grid>
              </TabPanel>

              <TabPanel>
                <Grid gap={4}>
                  <GridItem>
                    <Grid gap="1rem" templateColumns={"repeat(3, 1fr)"}>
                      <GridItem>
                        <Box>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                            mt="1rem"
                          >
                            Product Name{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Input
                            type="text"
                            color={"#141D43"}
                            border="2px solid  #8fd0fd !important"
                            marginTop="5px"
                            id="productName"
                            bg={"#fff"}
                            value={productValues.productName}
                            onChange={(e) => {
                              setProductValues({
                                ...productValues,
                                productName: e.target.value,
                              });
                            }}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                        </Box>
                      </GridItem>
                      <GridItem>
                        <Box>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                            mt="1rem"
                          >
                            Product Category{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Select
                            mt="5px"
                            bgColor="white"
                            color={" #464C64"}
                            border="2px solid  #8fd0fd !important"
                            id="productCategory"
                            fontSize="sm"
                            value={productValues.productCategory}
                            onChange={(e) => {
                              setProductValues({
                                ...productValues,
                                productCategory: e.target.value,
                              });
                            }}
                          >
                            <option hidden="true">
                              Select Product Category
                            </option>
                            {productCategory?.data?.map((data, index) => (
                              <option
                                default="true"
                                value={data?._id}
                                key={index}
                              >
                                {data?.name}
                              </option>
                            ))}
                          </Select>
                        </Box>
                      </GridItem>

                      <GridItem>
                        <Box>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                            mt="1rem"
                          >
                            Product Classification{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Select
                            mt="5px"
                            bgColor="white"
                            color={" #464C64"}
                            border="2px solid  #8fd0fd !important"
                            id="productClassification"
                            fontSize="sm"
                            value={productValues.productClassification}
                            onChange={(e) => {
                              setProductValues({
                                ...productValues,
                                productClassification: e.target.value,
                              });
                            }}
                          >
                            <option hidden="true">
                              Select Product Classification
                            </option>
                            {productClassification?.data?.map((data, index) => (
                              <option
                                default="true"
                                value={data?._id}
                                key={index}
                              >
                                {data?.name}
                              </option>
                            ))}
                          </Select>
                        </Box>
                      </GridItem>
                    </Grid>

                    <Grid templateColumns={"repeat(2, 1fr)"} gap="1rem">
                      <GridItem>
                        <Text
                          mt="1rem"
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Certification{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          mt="5px"
                          bgColor="white"
                          color={" #464C64"}
                          border="2px solid  #8fd0fd !important"
                          id="productCertification"
                          fontSize="sm"
                          value={productValues.productCertification}
                          onChange={(e) => {
                            setProductValues({
                              ...productValues,
                              productCertification: e.target.value,
                            });
                            getOneProgram(e.target.value);
                          }}
                        >
                          <option hidden="true">Select Certification</option>
                          {allPrograms?.data?.map((data, index) => (
                            <option
                              default="true"
                              value={data?._id}
                              key={index}
                            >
                              {data?.name}
                            </option>
                          ))}
                        </Select>
                      </GridItem>
                      <GridItem>
                        <Text
                          mt="1rem"
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Grade{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          mt="5px"
                          marginTop={"10px"}
                          bgColor="white"
                          color={" #464C64"}
                          border="2px solid  #8fd0fd !important"
                          id="productLabelGrade"
                          fontSize="sm"
                          onChange={(e) => {
                            setProductValues({
                              ...productValues,
                              productLabelGrade: e.target.value,
                            });
                            setShowCertified(true);
                          }}
                        >
                          <option hidden="true">Select Grade</option>
                          {program?.program_labelGrade?.map((data, index) => (
                            <option value={data?._id} key={index}>
                              {data?.name}
                            </option>
                          ))}
                        </Select>
                      </GridItem>
                    </Grid>
                    <Text
                      color={"#141D43"}
                      fontSize="lg"
                      marginTop={"2rem"}
                      width="100%"
                      fontWeight={"800"}
                      fontFamily={"font.roboto"}
                      borderBottom="2px solid #52BBFF"
                    >
                      Product Composition
                    </Text>
                    <Grid
                      width={"100%"}
                      templateColumns="repeat(2, 1fr)"
                      gap="3rem"
                      marginTop={"1rem"}
                      alignItems={"center"}
                    >
                      <GridItem colSpan={{ base: "2", lg: "2", xl: "1" }}>
                        <Text
                          color={"#141D43"}
                          fontSize="sm"
                          fontWeight={"800"}
                          fontFamily={"font.roboto"}
                        >
                          Certified Materials
                        </Text>
                        {program?.program_labelGrade?.length > 0 &&
                        showCertified
                          ? program?.program_labelGrade?.map((data, index) => (
                              <>
                                {data?.commodities?.map((data) => (
                                  <Text
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                    marginTop="1rem"
                                  >
                                    {data?.commodityId?.name !== ""
                                      ? data?.commodityId?.name
                                      : ""}
                                  </Text>
                                ))}
                              </>
                            ))
                          : "N/A"}
                      </GridItem>

                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="sm"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Non Certified Material
                        </Text>
                        <MultiSelect
                          marginTop={"10px"}
                          options={commodityValues}
                          value={selectedCommodityValue}
                          bgColor="white"
                          color={" #464C64"}
                          onChange={(value) => {
                            const newArr = value.map(
                              (value) =>
                                commodityValues.filter(
                                  (commodity) => commodity.label === value
                                )[0]
                            );
                            setCustomCommodityValue(newArr);
                            setSelectedCommodityValue(value);
                          }}
                        />
                      </GridItem>
                    </Grid>
                    <Button
                      bg={"#52BBFF"}
                      _hover={{ bg: "#3fa7eb" }}
                      onClick={() => addProducts(productValues)}
                      color="white"
                      cursor={"pointer"}
                      mt="1rem"
                    >
                      Add Product
                    </Button>
                  </GridItem>
                  <GridItem
                  // colSpan={{ base: "2", md: "2", lg: "1" }}
                  // height="400px"
                  // overflowY={products?.length > 3 ? "scroll" : "auto"}
                  // className="overflow-style"
                  // borderLeft={{ base: "", md: "", lg: "3px solid #52BBFF" }}
                  // paddingLeft={{ base: "", md: "", lg: "2rem" }}
                  >
                    <Text
                      color={"#141D43"}
                      fontSize="lg"
                      fontWeight={"800"}
                      marginBottom="5px"
                    >
                      List of Products added
                    </Text>
                    <Box
                      border={"2px solid #2272D5"}
                      width="15%"
                      marginBottom={"1rem"}
                    ></Box>
                    <Accordion allowToggle>
                      {products?.map((product) => (
                        <AccordionItem
                          key={product.id}
                          border="1px solid #E2E8F0"
                          borderRadius="md"
                          mb="1rem"
                        >
                          <h2>
                            <AccordionButton>
                              <Box
                                flex="1"
                                textAlign="left"
                                fontWeight="600"
                                color="#2272D5"
                              >
                                {product?.name || "Product Name Not Provided"}
                              </Box>
                              <AccordionIcon />
                            </AccordionButton>
                          </h2>

                          <AccordionPanel pb={4}>
                            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                              {/* Product Name */}
                              <GridItem>
                                <Text fontWeight="800">Product Name:</Text>
                                {editableProductId === product.id ? (
                                  <Input
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    value={tempEditProductData.name}
                                    onChange={(e) =>
                                      handleFieldProductChange(
                                        "name",
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  <Text>{product.name || "N/A"}</Text>
                                )}
                              </GridItem>

                              {/* Product Category */}
                              <GridItem>
                                <Text fontWeight="800">Product Category:</Text>
                                {editableProductId === product.id ? (
                                  <Select
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    fontSize="sm"
                                    id="productCategory"
                                    value={tempEditProductData.productCategory}
                                    onChange={(e) =>
                                      handleFieldProductChange(
                                        "productCategory",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option hidden="true">
                                      Select Category
                                    </option>
                                    {productCategory?.data?.map(
                                      (data, index) => (
                                        <option
                                          default="true"
                                          value={data?._id}
                                          key={index}
                                        >
                                          {data?.name}
                                        </option>
                                      )
                                    )}
                                  </Select>
                                ) : (
                                  <Text>
                                    {product?.productCategory
                                      ? getProductCategoryName(
                                          product?.productCategory
                                        )
                                      : "N/A"}
                                  </Text>
                                )}
                              </GridItem>

                              {/* Product Classification */}
                              <GridItem>
                                <Text fontWeight="800">
                                  Product Classification:
                                </Text>
                                {editableProductId === product.id ? (
                                  <Select
                                    marginTop={"10px"}
                                    bgColor="white"
                                    color={" #464C64"}
                                    border="2px solid  #8fd0fd !important"
                                    id="productClassification"
                                    fontSize="sm"
                                    value={
                                      tempEditProductData.productClassification
                                    }
                                    onChange={(e) =>
                                      handleFieldProductChange(
                                        "productClassification",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option hidden="true">
                                      Select Classification
                                    </option>
                                    {productClassification?.data?.map(
                                      (data, index) => (
                                        <option
                                          default="true"
                                          value={data?._id}
                                          key={index}
                                        >
                                          {data?.name}
                                        </option>
                                      )
                                    )}
                                  </Select>
                                ) : (
                                  <Text>
                                    {product?.productClassification
                                      ? getProductClassificationName(
                                          product?.productClassification
                                        )
                                      : "N/A"}
                                  </Text>
                                )}
                              </GridItem>

                              {/* Certification */}
                              <GridItem>
                                <Text fontWeight="800">Certification:</Text>
                                <Text>
                                  {editableProductId === product.id ? (
                                    <>
                                      <Select
                                        marginTop={"10px"}
                                        bgColor="white"
                                        color={" #464C64"}
                                        border="2px solid  #8fd0fd !important"
                                        id="program"
                                        fontSize="sm"
                                        value={tempEditProductData?.program}
                                        onChange={(e) =>
                                          handleFieldProductChange(
                                            "program",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option hidden="true">
                                          Select Certification
                                        </option>
                                        {allPrograms?.data?.map(
                                          (data, index) => (
                                            <option
                                              default="true"
                                              value={data?._id}
                                              key={index}
                                            >
                                              {data?.name}
                                            </option>
                                          )
                                        )}
                                      </Select>
                                    </>
                                  ) : product?.program ? (
                                    getProductCertificationName(
                                      product?.program
                                    )
                                  ) : (
                                    "N/A"
                                  )}
                                </Text>
                              </GridItem>

                              {/* Grade */}
                              <GridItem>
                                <Text fontWeight="800">Grade:</Text>
                                <Text>
                                  {editableProductId === product.id ? (
                                    <>
                                      <Select
                                        marginTop={"10px"}
                                        bgColor="white"
                                        color={" #464C64"}
                                        border="2px solid  #8fd0fd !important"
                                        id="productLabelGrade"
                                        fontSize="sm"
                                        value={
                                          tempEditProductData?.certifiedLabelGrade
                                        }
                                        onChange={(e) => {
                                          setTempEditProductData({
                                            ...tempEditProductData,
                                            certifiedLabelGrade: e.target.value,
                                          });
                                        }}
                                      >
                                        <option hidden="true">
                                          Select Grade
                                        </option>
                                        {tempEditProductData?.program &&
                                          allPrograms?.data
                                            ?.find(
                                              (data) =>
                                                data._id ===
                                                tempEditProductData.program
                                            )
                                            ?.program_labelGrade.map(
                                              (data, index) => (
                                                <option
                                                  value={data._id}
                                                  key={index}
                                                >
                                                  {data.name}
                                                </option>
                                              )
                                            )}
                                      </Select>
                                    </>
                                  ) : (
                                    <>
                                      {getProductLabelGradeName(
                                        tempEditProductData?.certifiedLabelGrade
                                      )}
                                    </>
                                  )}
                                </Text>
                              </GridItem>

                              {/* Certified Materials */}
                              <GridItem>
                                <Text fontWeight="800">
                                  Certified Materials:
                                </Text>
                                <Text>
                                  {(() => {
                                    let matchingCommodities = []; // Array to store matching commodity names

                                    allPrograms?.data?.forEach((program) => {
                                      // Checking if the object's _id matches with selectedProduct
                                      if (program?._id === product?.program) {
                                        // Accessing the program_labelGrade array
                                        program?.program_labelGrade?.forEach(
                                          (labelGrade) => {
                                            // Mapping the commodities array
                                            labelGrade?.commodities?.forEach(
                                              (commodity) => {
                                                matchingCommodities.push(
                                                  commodity?.commodityId?.name
                                                );
                                              }
                                            );
                                          }
                                        );
                                      }
                                    });

                                    if (matchingCommodities.length === 0) {
                                      return <Text>N/A</Text>; // Render "N/A" if no matches were found
                                    }

                                    return matchingCommodities?.map(
                                      (commodityName, index) => (
                                        <Text key={index}>{commodityName}</Text>
                                      )
                                    );
                                  })()}
                                </Text>
                              </GridItem>

                              {/* Non-Certified Materials */}
                              <GridItem>
                                <Text fontWeight="800">
                                  Non-Certified Materials:
                                </Text>
                                <Text>
                                  {editableProductId === product.id ? (
                                    <>
                                      <MultiSelect
                                        marginTop={"10px"}
                                        options={commodityValues}
                                        value={tempEditProductData?.ncProductComposition?.map(
                                          (comp) => {
                                            const matchingCommodity =
                                              commodityValues.find(
                                                (commodity) =>
                                                  commodity.id ===
                                                  comp.commodity
                                              );
                                            return matchingCommodity
                                              ? matchingCommodity.label
                                              : "";
                                          }
                                        )}
                                        onChange={(values) => {
                                          const newArr = values.map(
                                            (value) =>
                                              commodityValues.filter(
                                                (commodity) =>
                                                  commodity.label === value
                                              )[0]
                                          );

                                          const updatedComposition = newArr.map(
                                            (value) => ({
                                              commodity: value?.id,
                                            })
                                          );
                                          setTempEditProductData(
                                            (tempEditProductData) => {
                                              return {
                                                ...tempEditProductData,
                                                ncProductComposition:
                                                  updatedComposition,
                                              };
                                            }
                                          );
                                        }}
                                        bgColor="white"
                                        color={"#464C64"}
                                        border="2px solid #8fd0fd !important"
                                        placeholder="Select Non-Certified Materials"
                                      />
                                    </>
                                  ) : product?.ncProductComposition?.length ===
                                    0 ? (
                                    "N/A"
                                  ) : (
                                    product?.ncProductComposition
                                      ?.map((comp) => {
                                        const matchingCommodity =
                                          commodityValues.find(
                                            (commodity) =>
                                              commodity.id === comp.commodity
                                          );
                                        return matchingCommodity
                                          ? matchingCommodity.label
                                          : "N/A";
                                      })
                                      .join(", ")
                                  )}
                                </Text>
                              </GridItem>
                            </Grid>

                            {/* Action Buttons */}
                            {/* <Box
                              display="flex"
                              justifyContent="flex-end"
                              mt="1rem"
                            >
                              {editableProductId === product.id ? (
                                <>
                                  <Button
                                    colorScheme="green"
                                    mr={3}
                                    onClick={saveProductChanges}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    onClick={() => setEditableProductId(null)}
                                  >
                                    Cancel
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  colorScheme="blue"
                                  onClick={() =>
                                    handleEditProductClick(product)
                                  }
                                >
                                  Edit
                                </Button>
                              )}
                            </Box> */}
                          </AccordionPanel>
                        </AccordionItem>
                      ))}
                    </Accordion>
                  </GridItem>
                </Grid>
                <Box mt="2rem">
                  <Box mt="1rem" mb="1rem">
                    <Text fontSize="md" fontWeight={"800"}>
                      Upload GST/Company Document{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                  </Box>
                  <Grid templateColumns="repeat(5,1fr)">
                    <GridItem colSpan={1}>
                      <Button
                        w={"200px"}
                        h={"150px"}
                        bg={"#FFFFFF"}
                        leftIcon={<FiUpload />}
                        borderRadius={"15px"}
                        as="label"
                        htmlFor="file-upload"
                        variant="outline"
                      >
                        Upload files
                        <VisuallyHidden>
                          <input
                            id="file-upload"
                            type="file"
                            multiple
                            onChange={(event) => handleFileUpload(event)}
                          />
                        </VisuallyHidden>
                      </Button>
                    </GridItem>
                    <GridItem colSpan={4}>
                      <Box
                        display={"flex"}
                        overflowX={files?.length > 4 ? "scroll" : "auto"}
                        maxWidth="100%"
                        className="overflow-style"
                      >
                        {files.map((file, index) => (
                          <Box
                            bg="#FFFFFF"
                            key={index}
                            minW={"200px"}
                            h={"150px"}
                            borderRadius={"15px"}
                            mx={"1rem"}
                            boxShadow={"lg"}
                          >
                            <Box display={"flex"} justifyContent={"right"}>
                              <Button
                                borderColor="#FFFFFF"
                                bg="#ffffff"
                                size="sm"
                                variant="outline"
                                onClick={() => handleRemoveFile(index)}
                                leftIcon={<RemoveIcon />}
                              ></Button>
                            </Box>
                            <Tooltip label={file.name}>
                              <Box>
                                <Box display={"flex"} justifyContent={"center"}>
                                  <FileIcon />
                                </Box>

                                <Text
                                  width={"130px"}
                                  whiteSpace={"nowrap"}
                                  overflow={"hidden"}
                                  textOverflow={"ellipsis"}
                                  m="1rem auto"
                                >
                                  {file.name}
                                </Text>
                              </Box>
                            </Tooltip>
                          </Box>
                        ))}
                      </Box>
                    </GridItem>
                  </Grid>
                  <Box display={"flex"} justifyContent={"center"}>
                    {errorMessage && (
                      <Box
                        bg="crimson"
                        color="white"
                        p="1rem"
                        borderRadius="15px"
                        mb="1rem"
                        w="60%"
                        textAlign={"center"}
                      >
                        {errorMessage}
                        <Button
                          size="sm"
                          variant="outline"
                          ml="1rem"
                          bg="white"
                          color="black"
                          onClick={clearErrorMessage}
                        >
                          <RemoveIcon />
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Button
                  mt="1rem"
                  colorScheme="blue"
                  isLoading={isLoading}
                  onClick={handleFinalSubmit}
                >
                  Submit
                </Button>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ScopeExtensionModal;
